import React, {useEffect, useState} from "react";
import SVG from "react-inlinesvg";
import { Modal, Form, Col } from "react-bootstrap";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../../../../../../../../../_metronic/_helpers";
import * as handlers from "../../../../../../../../_redux/selected-user/selectedUserHandlers"

const WithdrawModal = ({showWithdrawModal, onHide, match, currency, refreshPayments}) => {

    const dispatch = useDispatch();
    /* Get User Bank Accounts from redux */
    const {bankAccounts, profile} = useSelector(({selectedUser}) => selectedUser.data, shallowEqual);

    const [selectedChannel, setSelectedChannel] = useState(null);
    const [validated, setValidated] = useState(false);

    const bankAccountFilter = bankAccounts?.filter(acc => (selectedChannel!= null && 
                                                        ((selectedChannel === "NUBAN" && acc.currency === "NGN") || 
                                                        (selectedChannel === "WIRE" && acc.currency !== "NGN")))
                                                    )
                                        .map((acc, i) => <option key={`bk-${i}`} value={acc.ref}>
                                                {`${acc.bankName}***${acc.accountNumber.substr(-4)} - ${acc.currency}`}
                                            </option>)


    // Create Withdrawal for User
    const handleSubmitWithdrawal = e => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;
        if (form.checkValidity() === true) {
            const formData = new FormData(form);
            const userId = match.params.userId;
            const accountId = match.params.accountId;
            const data = {...Object.fromEntries(formData.entries()), userId, accountId};
            data.meta = {...profile.basic, currency, bankAccount: bankAccounts?.filter(acc => acc.ref === data.bankAccountRef)[0]}
            onHide();
            dispatch(handlers.createWithdrawal(data))
                .then(() => {
                    if (refreshPayments) {
                        refreshPayments();
                    }
                });
        }
        setValidated(true);
    }

    // Get User Bank Accounts
    useEffect(() => {
        if (!bankAccounts){
            dispatch(handlers.fetchUserBankAccounts(match.params.userId));
        }
    }, [dispatch, bankAccounts, match.params.userId]);


  return (
    <Modal
        show={showWithdrawModal}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        onExited={_ => setValidated(false)}
      >
      
        <Form
            noValidate
            validated={validated}
            onSubmit={handleSubmitWithdrawal}
        >
            <Modal.Header >
            <Modal.Title id="contained-modal-title-vcenter">
                
                <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                    <SVG
                        title=""
                        src={toAbsoluteUrl("/media/svg/icons/Shopping/Wallet3.svg")}
                    />
                </span>
                Withdraw to Bank Account
            </Modal.Title>
            <button type="button" className="close" onClick={onHide}>
                <span aria-hidden="true" className="d-block">×</span>
                <span className="sr-only">Close</span>
            </button>
            </Modal.Header>
            <Modal.Body 
                className="px-10 py-2"
            >
                
                <div className="row mt-5">
                    <div className="col-lg-5 pr-5">
                        <h6 className="mb-0 pt-3">Channel</h6>
                    </div>                   
                    <Form.Group as={Col} controlId="channel">
                        <Form.Control
                            required
                            as="select"
                            className="mr-sm-2"
                            custom
                            name="channel"
                            onChange={e => setSelectedChannel(e.currentTarget.value)}
                        >
                            <option value=""></option>
                            <option value="NUBAN">NUBAN</option>
                            <option value="WIRE">WIRE</option>
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                            Select Withdrawal Channel
                        </Form.Control.Feedback>
                    </Form.Group>
                </div>

                            
                <div className="row">
                    <div className="col-lg-5 pr-5">
                        <h6 className="mb-0 pt-3">Bank Account</h6>
                    </div>                   
                    <Form.Group as={Col} controlId="bankAccountRef">
                        <Form.Control
                            required
                            as="select"
                            className="mr-sm-2"
                            custom
                            name="bankAccountRef"
                        >
                            <option value=""></option>
                            {bankAccountFilter}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                            Select Bank Account
                        </Form.Control.Feedback>
                    </Form.Group>
                </div>
                            
                <div className="row">
                    <div className="col-lg-5 pr-5">
                        <h6 className="mb-0 pt-3">Amount in {currency}</h6>
                    </div>                   
                    <Form.Group as={Col} controlId="bankRef">
                        <Form.Control
                            required
                            type="text"
                            name="amount"
                            pattern="^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$"
                            autoComplete="off"
                        />
                        <Form.Control.Feedback type="invalid">
                            Enter Valid Amount
                        </Form.Control.Feedback>
                    </Form.Group>
                </div>

                
            </Modal.Body>
            <Modal.Footer className="justify-content-centerx">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-light btn-elevate px-4"
                >
                    Cancel
                </button>
                <> </>
                <button
                    type="submit"
                    className="btn btn-primary btn-elevate px-4 ml-4"
                >
                    Withdraw
                </button>
            </Modal.Footer>
        </Form>
      </Modal>

        );
}

export default WithdrawModal;